<template>
    <v-card flat class="px-2">
        <v-checkbox
            v-model="showDetails"
            :label="$t('params.showParameterDetails')"
            dense
            class="ml-2"
        />
        <v-row>
            <template
                    v-for="group in configGroups"
            >
                <v-col cols="6"
                       class="pr-12"
                       :key="'groupMenuConfigs'+group.name"
                >
                    <v-subheader>{{groupDisplayName(group)}}</v-subheader>
                    <v-divider></v-divider>
                    <v-list>
                        <v-list-item
                                v-for="config in group.contents"
                                :key="group.name+config.name"
                                @click="startEdit(config.name)"
                                :disabled="publisherIsConsortialProposalSet || !iCanEdit"

                        >
                            <v-list-item-content>
                                <div>
                                    {{paramDisplayName(config)}}
                                </div>
                                <div v-if="showDetails" class="body-2" style="color: #555;">
                                    {{paramDescr(config)}}
                                </div>
                            </v-list-item-content>
                            <v-list-item-action class="font-weight-bold pl-2">
                                <settings-item-value :config-name="config.name"/>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-col>
            </template>

        </v-row>

        <v-dialog v-model="showDialog" max-width="500" persistent>
            <v-card v-if="showDialog">
                <v-card-title>
                    <v-icon left>mdi-cog-outline</v-icon>
                    {{paramDisplayName(selectedConfigData)}}
                </v-card-title>

                <div v-if="institutionIsConsortium">
                    <v-alert
                            color="warning"
                            text
                            icon="mdi-alert"
                    >
                        <p class="font-weight-bold">{{ $t('params.couldTakeAWhile') }}</p>
                        <p>
                            {{ $t('params.recalcWarning') }}
                        </p>
                        <p>{{ $t('params.recalcEmailNotice', { email: userEmail }) }}</p>
                    </v-alert>

                </div>

                <v-card-text class="pt-4">
                    <div>
                        <v-text-field
                                v-if="selectedConfigData.display==='dollars'"
                                outlined
                                type="number"
                                :disabled="savingConfig"
                                @keydown.enter="saveEdit"
                                :prefix="publisherCurrencySymbol"
                                v-model="selectedConfigValue"
                        />
                        <v-text-field
                                v-if="selectedConfigData.display==='percent'"
                                outlined
                                type="number"
                                :disabled="savingConfig"
                                @keydown.enter="saveEdit"
                                suffix="%"
                                v-model="selectedConfigValue"
                        />
                        <v-text-field
                                v-if="selectedConfigData.display==='number'"
                                outlined
                                type="number"
                                :disabled="savingConfig"
                                @keydown.enter="saveEdit"
                                v-model="selectedConfigValue"
                        />
                        <v-switch
                                v-if="selectedConfigData.display==='boolean'"
                                color="primary"
                                :disabled="savingConfig"
                                v-model="selectedConfigValue"
                                :label="paramDisplayName(selectedConfigData)"
                        />
                    </div>
                    <div class="descr">
                        {{paramDescr(selectedConfigData)}}
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn depressed @click="cancelEdit">{{ $t('common.cancel') }}</v-btn>
                    <v-btn
                            depressed
                            @click="saveEdit"
                            :loading="savingConfig"
                            color="primary"
                    >
                        {{ (institutionIsConsortium) ? $t('params.saveAndWait') : $t('common.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-card>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex'
    import appConfigs from "../../appConfigs";
    import SettingsItemValue from "../Settings/SettingsItemValue";

    export default {
        name: "ScenarioParametersTab",
        components: {
            SettingsItemValue,
        },
        props: {
            myRole: String,
            isConsortialFeeder: Boolean,
            publishers: Array,
        },
        data() {
            return {
                selectedConfigValue: null,
                showDialog: false,
                selectedConfigName: null,
                savingConfig: false,
                showDetails: true,
            }
        },
        methods: {
            ...mapMutations([
                "snackbar",
            ]),
            paramDisplayName(config) {
                const map = {
                    cost_alacart_increase: 'params.titleByTitleGrowth',
                    cost_content_fee_percent: 'params.contentFee',
                    cost_ill: 'params.illTransactionCost',
                    ill_request_percent_of_delayed: 'params.illRequestRate',
                    include_bronze: 'params.includeBronzeOA',
                    include_submitted_version: 'params.permitNonPeerReviewed',
                    include_social_networks: 'params.includeResearchGate',
                    weight_authorship: 'params.authorshipWeight',
                    weight_citation: 'params.citationWeight',
                }
                const key = config && map[config.name]
                return key ? this.$t(key) : (config && config.displayName)
            },
            paramDescr(config) {
                const map = {
                    cost_alacart_increase: 'params.titleByTitleGrowthDescr',
                    cost_content_fee_percent: 'params.contentFeeDescr',
                    cost_ill: 'params.illTransactionCostDescr',
                    ill_request_percent_of_delayed: 'params.illRequestRateDescr',
                    include_bronze: 'params.includeBronzeOADescr',
                    include_submitted_version: 'params.permitNonPeerReviewedDescr',
                    include_social_networks: 'params.includeResearchGateDescr',
                    weight_authorship: 'params.authorshipWeightDescr',
                    weight_citation: 'params.citationWeightDescr',
                }
                const key = config && map[config.name]
                return key ? this.$t(key) : (config && config.descr)
            },
            groupDisplayName(group) {
                const map = {
                    costs: 'params.costs',
                    ill: 'params.ill',
                    fulfillment: 'params.fulfillmentSources',
                    usageWeights: 'params.citationAuthorship',
                }
                const key = map[group.name]
                return key ? this.$t(key) : group.displayName
            },
            startEdit(configName) {
                // this.$refs.settingsMenu.isActive = false
                this.showDialog = true
                this.selectedConfigName = configName
                this.selectedConfigValue = this.$store.getters.config(configName)
            },
            async saveEdit() {
                console.log("saving config edit", this.selectedConfigValue)
                this.savingConfig = true
                await this.$store.dispatch("setSelectedScenarioConfig", {
                    key: this.selectedConfigName,
                    value: this.selectedConfigValue,
                })
                this.cancelEdit()
                if (!this.institutionIsConsortium) {
                    this.$store.commit("snackbar", this.$t('params.settingUpdated'))
                }
            },
            cancelEdit() {
                this.selectedConfigName = null
                this.selectedConfigValue = null
                this.showDialog = false
                this.savingConfig = false
            },
        },
        computed: {
            ...mapGetters([
                'institutionId',
                'institutionName',
                'institutionIsDemo',
                "institutionIsConsortium",
                "institutionUsersWithRoles",
                'userConsortia',
                'userInstitutions',
                'publisherIsConsortialProposalSet',
                'publisherId',
                'scenarioName',
                'userEmail',
            ]),
            configGroups: () => appConfigs.scenarioConfigGroups,
            selectedConfigData() {
                return appConfigs.scenarioConfigs[this.selectedConfigName]
            },
            iCanEdit() {
              if (this.scenarioName.includes("Walkaway")) {
                console.log("in iCanEdit: " + this.userEmail)
                return ["jisc.ac.uk", "ourresearch.org"].includes(this.userEmail.split('@')[1])
              } else {
                return true
              }
            },

        },
        created() {
        },
        mounted() {
        },
        watch: {
            "foo": {
                immediate: true,
                handler: function (to, from) {
                }
            }
        }
    }
</script>

<style lang="scss">


</style>
